import styled from 'styled-components';

import {Device} from '../../../../constants';

import Content from './Content';
import VBucksImage from './VBucksImage';

const CrewSectionContainer = styled.section`
  display: flex;
  width: 100%;
  position: relative;
  height: 100%;
  z-index: 1;
  justify-content: center;

  ${Content} {
    max-width: 65%;
    margin-top: 100px;

    @media screen and ${Device.tablet} {
      max-width: 100%;
    }
  }

  .crew-image {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media screen and ${Device.laptop} {
      width: 100%;
    }
    @media screen and ${Device.tablet} {
      max-width: 100%;
    }

    ${VBucksImage} {
      position: relative;
      width: 100%;
      height: auto;
      max-width: 75%;

      @media screen and ${Device.laptop} {
        width: 100%;
        max-width: 390px;
        height: auto;
        margin: 0 auto;
      }
      @media screen and ${Device.mobileL} {
        width: 100%;
        height: auto;
        margin: 0 auto;
      }
    }
  }

  @media screen and (max-width: 975px) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 1em;
  }
`;

export default CrewSectionContainer;
